import { render, staticRenderFns } from "./u-txt-medium.vue?vue&type=template&id=8214c484&scoped=true&"
import script from "./u-txt-medium.vue?vue&type=script&lang=js&"
export * from "./u-txt-medium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8214c484",
  null
  
)

export default component.exports